import React, { useState, useRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const genId = () =>
  (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `inp_${Math.random().toString(36).slice(2, 10)}`;

const Input = ({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  className = '',
  autoComplete,
  name,
  id,
  ...rest
}) => {
  // Stable auto id across re-renders (won't change)
  const autoIdRef = useRef(id || genId());
  const inputId = id || autoIdRef.current;

  const isPassword = type === 'password';
  const [visible, setVisible] = useState(false);

  const computedType = isPassword ? (visible ? 'text' : 'password') : type;
  const computedAutoComplete = autoComplete ?? (isPassword ? 'new-password' : 'off');
  const computedName = name ?? (isPassword ? 'new-password' : undefined);

  return (
    <div className="flex flex-col">
      {label && (
        <label
          htmlFor={inputId}
          className="text-xs font-regular mb-0.5 text-gray-700 flex items-center gap-1"
        >
          {label}
        </label>
      )}

      <div className="relative">
        <input
          id={inputId}
          type={computedType}
          value={value ?? ''}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={computedAutoComplete}
          name={computedName}
          autoCorrect="off"
          spellCheck={false}
          autoCapitalize="off"
          className={`ws-input form-input w-full text-gray-600 text-md bg-gray-100 focus:outline-none text-sm px-3 py-2 pr-10 rounded ${className}`}
          {...(isPassword ? { 'data-lpignore': 'true', 'data-1p-ignore': 'true' } : {})}
          {...rest}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setVisible(v => !v)}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400"
            aria-label={visible ? 'Hide password' : 'Show password'}
            title={visible ? 'Hide password' : 'Show password'}
          >
            {visible ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default Input;
